import { assert } from './utilities/ErrorHandling';
import Action from "./Action";
import store, { StoreActions } from '../state/store';
import { CustomEventTypes, NativeElementTags } from '../globals';

function onActionsUpdated()
{
	const actionsForRedux = ActionManager.actionStack.map((action, index) =>
	{
		return {
			id: action.id,
			name: action.name,
			index: index
		};
	});
	store.dispatch(StoreActions.history.setActionHistoryStack(actionsForRedux));

	if (ActionManager.currentActionIndex >= 0)
	{
		store.dispatch(
			StoreActions.history.setCurrentAction({
				index: ActionManager.currentActionIndex,
				id: ActionManager.actionStack[ActionManager.currentActionIndex].getId()
			})
		);
	}
	else
	{
		store.dispatch(
			StoreActions.history.setCurrentAction({ id: 0,
				index: ActionManager.currentActionIndex })
		);
	}
}

export default class ActionManager
{
	static actionStack: Action[] = [];
	static currentActionIndex = -1;

	static getActionByIndex(idx: number)
	{
		return ActionManager.actionStack[idx];
	}

	static getCurrentAction()
	{
		return ActionManager.actionStack[ActionManager.currentActionIndex];
	}

	static pushAction(action: Action)
	{
		if (ActionManager.currentActionIndex !== ActionManager.actionStack.length - 1)
		{
			for (let i = ActionManager.currentActionIndex + 1; i < ActionManager.actionStack.length - 1; i++)
			{
				ActionManager.actionStack[i].onDelete();
			}
		}

		ActionManager.actionStack = [
			...ActionManager.actionStack.slice(0, ActionManager.currentActionIndex + 1),
			action
		];

		ActionManager.currentActionIndex = ActionManager.actionStack.length - 1;
		onActionsUpdated();
	}

	static clearHistory()
	{
		for (const action of ActionManager.actionStack)
		{
			action.onDelete();
		}
		ActionManager.currentActionIndex = -1;
		ActionManager.actionStack = [];
		onActionsUpdated();
	}

	static jumpToPoint(index: number)
	{
		assert(index >= 0 && index < ActionManager.actionStack.length);
		if (index === ActionManager.currentActionIndex) return;

		if (index < ActionManager.currentActionIndex)
		{
			while (ActionManager.currentActionIndex !== index)
			{
				ActionManager.undo();
			}
		}
		else
		{
			while (ActionManager.currentActionIndex !== index)
			{
				ActionManager.redo();
			}
		}
	}

	static undo()
	{
		if (NativeElementTags.includes(document.activeElement?.tagName as string))
		{
			return;
		}

		if (ActionManager.currentActionIndex >= 0)
		{
			const action = ActionManager.actionStack[ActionManager.currentActionIndex];
			action.undo(...action.undoParams!);
			action.afterUndo();
			ActionManager.currentActionIndex--;
			onActionsUpdated();

			document.dispatchEvent(new CustomEvent(CustomEventTypes.onUndo));
		}
	}

	static redo()
	{
		if (NativeElementTags.includes(document.activeElement?.tagName as string))
		{
			return;
		}

		if (ActionManager.currentActionIndex < ActionManager.actionStack.length - 1)
		{
			ActionManager.currentActionIndex++;
			ActionManager.actionStack[ActionManager.currentActionIndex].do(...ActionManager.actionStack[ActionManager.currentActionIndex].doParams!);
			onActionsUpdated();

			document.dispatchEvent(new CustomEvent(CustomEventTypes.onRedo));
		}
	}

	static getActionCount()
	{
		return ActionManager.actionStack.length;
	}

	static isActionActive(action: Action)
	{
		const actionIndex = ActionManager.actionStack.indexOf(action);
		return actionIndex >= 0 && actionIndex <= ActionManager.currentActionIndex;
	}

	static removeAllTemporaryActions()
	{
		for (let i = ActionManager.actionStack.length - 1; i >= 0; i--)
		{
			if (ActionManager.actionStack[i].isTemporary)
			{
				ActionManager.actionStack[i].onDelete();
				ActionManager.actionStack.splice(i, 1);

				if(ActionManager.currentActionIndex >= i)
				{
					ActionManager.currentActionIndex--;
				}
			}
		}
		onActionsUpdated();
	}
}



